export interface MangaItem {
  slug: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  status: 'finished' | 'serializing';
  views: number;
  rating: number;
  authors: string;
  chapters: number;
  update: string;
  intro: string;
}

export interface MangaCategory {
  slug: string;
  name: string;
  description: string;
}

export const mangaCategories: MangaCategory[] = [
  { slug: 're-xue', name: '热血冒险', description: '燃烧的少年魂，伙伴与战斗的冒险之旅' },
  { slug: 'xuan-huan', name: '玄幻修仙', description: '东方玄幻与仙侠世界，境界与命运的对抗' },
  { slug: 'lian-ai', name: '恋爱甜宠', description: '怦然心动的青春恋爱与甜宠日常' },
  { slug: 'xuan-yi', name: '悬疑推理', description: '烧脑谜题与反转剧情，真相隐藏其中' },
  { slug: 'gao-xiao', name: '搞笑日常', description: '轻松爆笑的校园与日常喜剧' },
  { slug: 'ke-huan', name: '科幻末世', description: '未来科技与末日世界观下的生存与救赎' },
];

export const allTags: string[] = [
  '热血', '战斗', '友情', '奇幻', '修仙', '穿越',
  '恋爱', '校园', '甜宠', '悬疑', '推理', '反转',
  '搞笑', '日常', '治愈', '科幻', '末世', '机甲',
];

export const mangaList: MangaItem[] = [
  {
    slug: 'yanhuo-shaonian', title: '烟火少年', category: '热血冒险',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20anime%20style%20illustration%20of%20a%20young%20hero%20in%20flaming%20battle%20pose%2C%20fiery%20orange%20and%20vermilion%20color%20palette%2C%20dramatic%20energy%20burst%2C%20vibrant%20manga%20cover%20art%2C%20clean%20composition%2C%20high%20detail&width=480&height=640&seq=manga-yanhuo-01&orientation=portrait',
    tags: ['热血', '战斗', '友情'], status: 'serializing', views: 986000, rating: 9.2,
    authors: '林一川', chapters: 128, update: '2026-08-15',
    intro: '少年燕火背负着家族遗志，在纷乱的武道大陆上踏上寻亲之路。每一次燃烧生命力量的对决，都让他离真相更近一步。这是一个关于伙伴、勇气与传承的燃烧故事。',
  },
  {
    slug: 'jianlai', title: '剑来山河', category: '热血冒险',
    cover: 'https://readdy.ai/api/search-image?query=epic%20anime%20illustration%20of%20a%20swordsman%20with%20a%20glowing%20sword%20standing%20before%20a%20grand%20mountain%20landscape%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20ink%20wash%20manga%20style%2C%20dramatic%20lighting%2C%20detailed%20linework&width=480&height=640&seq=manga-jianlai-02&orientation=portrait',
    tags: ['战斗', '玄幻', '友情'], status: 'serializing', views: 1203000, rating: 9.5,
    authors: '白鹤鸣', chapters: 256, update: '2026-08-16',
    intro: '一剑开天门，万剑镇山河。少年剑客云逸横空出世，在宗门林立、剑道争锋的大世中，以手中之剑问鼎天下，守护心中在意之人。',
  },
  {
    slug: 'haidao-shi', title: '海岛的星海', category: '热血冒险',
    cover: 'https://readdy.ai/api/search-image?query=ocean%20adventure%20anime%20illustration%20of%20a%20young%20pirate%20captain%20with%20a%20flag%20against%20a%20sunset%20sea%2C%20teal%20and%20gold%20palette%2C%20dynamic%20manga%20cover%2C%20sailing%20ships%20and%20islands%2C%20adventurous%20spirit%2C%20detailed&width=480&height=640&seq=manga-haidao-03&orientation=portrait',
    tags: ['热血', '冒险', '友情'], status: 'finished', views: 2100000, rating: 9.0,
    authors: '风之谷', chapters: 320, update: '2026-07-20',
    intro: '为了追寻传说中的星海宝藏，少年船长阿澈与他的伙伴们扬帆起航，穿越风暴、对抗海贼，在广袤的星海之上写下属于自己的传奇。',
  },
  {
    slug: 'junwu-huoquan', title: '君武火焰', category: '玄幻修仙',
    cover: 'https://readdy.ai/api/search-image?query=martial%20arts%20fantasy%20anime%20illustration%20of%20a%20warrior%20surrounded%20by%20blue%20and%20orange%20fire%2C%20floating%20swords%2C%20xia%20warrior%20style%2C%20warm%20vermilion%20tone%2C%20dynamic%20manga%20cover%20art%2C%20high%20detail&width=480&height=640&seq=manga-junwu-04&orientation=portrait',
    tags: ['玄幻', '修仙', '战斗'], status: 'serializing', views: 875000, rating: 8.8,
    authors: '赤焰', chapters: 96, update: '2026-08-14',
    intro: '天生废柴却身怀神秘火焰的少年君武，在修仙界步步崛起。以火焰淬炼本心，以不屈对抗天命，一步步踏上君临武道的巅峰。',
  },
  {
    slug: 'xianlu-chong', title: '仙路重生', category: '玄幻修仙',
    cover: 'https://readdy.ai/api/search-image?query=immortal%20cultivation%20anime%20illustration%20of%20a%20young%20immortal%20in%20flowing%20robes%20holding%20a%20jade%20sword%2C%20misty%20mountains%20and%20clouds%2C%20gold%20and%20teal%20palette%2C%20manga%20cover%2C%20mystical%20atmosphere%2C%20detailed%20linework&width=480&height=640&seq=manga-xianlu-05&orientation=portrait',
    tags: ['修仙', '穿越', '玄幻'], status: 'finished', views: 1580000, rating: 9.1,
    authors: '青玄真人', chapters: 410, update: '2026-06-30',
    intro: '渡劫失败的仙尊一朝重生回到少年时代，带着前世记忆与无上功法，他重新踏上仙路，弥补遗憾，改写命运，终登仙途之巅。',
  },
  {
    slug: 'chunfeng-xiyue', title: '春风习习', category: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=sweet%20romance%20anime%20illustration%20of%20a%20blushing%20girl%20and%20boy%20under%20cherry%20blossoms%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20warm%20and%20tender%20manga%20cover%2C%20gentle%20lighting%2C%20high%20detail%20clean%20style&width=480&height=640&seq=manga-chunfeng-06&orientation=portrait',
    tags: ['恋爱', '校园', '甜宠'], status: 'serializing', views: 1120000, rating: 9.0,
    authors: '小满', chapters: 88, update: '2026-08-15',
    intro: '春风起时，樱花树下，少女与同桌少年之间悄然萌生的心动。一场温柔治愈的校园恋爱，在平凡日常里开出花来。',
  },
  {
    slug: 'yuexia-chaoxi', title: '月下潮汐', category: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20anime%20illustration%20of%20a%20couple%20by%20the%20moonlit%20sea%20at%20night%2C%20soft%20moonlight%20and%20ocean%20blue%20with%20warm%20lights%2C%20dreamy%20tender%20manga%20cover%2C%20atmospheric%20and%20detailed&width=480&height=640&seq=manga-yuexia-07&orientation=portrait',
    tags: ['恋爱', '治愈', '甜宠'], status: 'serializing', views: 960000, rating: 9.3,
    authors: '汐语', chapters: 72, update: '2026-08-13',
    intro: '月光下的海边小镇，两个受伤的灵魂因一场潮汐相遇。在潮起潮落间彼此治愈，这是一部关于爱与救赎的温暖故事。',
  },
  {
    slug: 'mimi-jiaoshi', title: '秘密教室', category: '悬疑推理',
    cover: 'https://readdy.ai/api/search-image?query=mystery%20thriller%20anime%20illustration%20of%20an%20empty%20classroom%20with%20a%20dark%20shadowy%20figure%2C%20moody%20dark%20blue%20and%20crimson%20tones%2C%20suspenseful%20manga%20cover%2C%20chalkboard%20and%20desks%2C%20eerie%20atmosphere%2C%20high%20detail&width=480&height=640&seq=manga-mimi-08&orientation=portrait',
    tags: ['悬疑', '推理', '校园'], status: 'serializing', views: 1300000, rating: 9.4,
    authors: '墨影', chapters: 60, update: '2026-08-16',
    intro: '转学生发现教室里每个人都在隐藏一个秘密。当第一个人消失后，谜团层层展开，真相远比想象中更加黑暗而惊人。',
  },
  {
    slug: 'jingye-zhuiying', title: '静夜追影', category: '悬疑推理',
    cover: 'https://readdy.ai/api/search-image?query=noir%20detective%20anime%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20with%20a%20flashlight%20in%20a%20dark%20rainy%20alley%2C%20deep%20blue%20and%20gray%20palette%20with%20warm%20accent%2C%20mystery%20manga%20cover%2C%20cinematic%20lighting%2C%20detailed&width=480&height=640&seq=manga-jingye-09&orientation=portrait',
    tags: ['悬疑', '推理', '反转'], status: 'finished', views: 1400000, rating: 9.2,
    authors: '夜行者', chapters: 150, update: '2026-07-28',
    intro: '资深侦探阿夜接手一桩连环悬案，每个案发现场都留下相同的影子标记。在追查真相的过程中，他发现所有线索都指向自己。',
  },
  {
    slug: 'budao-xiaowang', title: '不倒小王子', category: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=funny%20comedy%20anime%20illustration%20of%20a%20clumsy%20cheerful%20boy%20with%20a%20comic%20face%20sliding%20on%20a%20banana%2C%20bright%20warm%20yellow%20and%20cream%20tones%2C%20lighthearted%20manga%20cover%2C%20cartoon%20style%2C%20vibrant%20and%20fun&width=480&height=640&seq=manga-budao-10&orientation=portrait',
    tags: ['搞笑', '日常', '校园'], status: 'serializing', views: 890000, rating: 8.9,
    authors: '木偶', chapters: 110, update: '2026-08-12',
    intro: '传说中永远不会倒下的少年小王子，其实是个每天都在花式翻车的倒霉蛋。爆笑的日常喜剧，笑到停不下来。',
  },
  {
    slug: 'zhoumo-yatou', title: '周末鸭头', category: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=whimsical%20comedy%20anime%20illustration%20of%20a%20cute%20duck%20character%20in%20a%20cozy%20kitchen%20scene%2C%20soft%20warm%20colors%2C%20lighthearted%20slice%20of%20life%20manga%20cover%2C%20charming%20and%20playful%2C%20high%20detail&width=480&height=640&seq=manga-zhoumo-11&orientation=portrait',
    tags: ['搞笑', '日常', '治愈'], status: 'finished', views: 720000, rating: 8.7,
    authors: '麻薯', chapters: 200, update: '2026-06-18',
    intro: '一只会说人话的鸭子住进了少女的家，从此鸡飞狗跳的欢乐日常开始了。治愈又爆笑的合租生活故事。',
  },
  {
    slug: 'xingji-kuangtu', title: '星际狂徒', category: '科幻末世',
    cover: 'https://readdy.ai/api/search-image?query=sci-fi%20anime%20illustration%20of%20a%20rebel%20pilot%20in%20front%20of%20a%20mecha%20in%20deep%20space%2C%20cyan%20and%20orange%20high%20contrast%2C%20futuristic%20manga%20cover%2C%20stars%20and%20nebula%2C%20epic%20and%20detailed&width=480&height=640&seq=manga-xingji-12&orientation=portrait',
    tags: ['科幻', '机甲', '热血'], status: 'serializing', views: 1450000, rating: 9.1,
    authors: '星火', chapters: 78, update: '2026-08-15',
    intro: '在资源枯竭的星际乱世，落魄机师阿狂驾驶着最破旧的机甲，闯出一条反抗帝国统治的血路。燃到爆炸的科幻机甲传奇。',
  },
  {
    slug: 'mori-baodian', title: '末日报点', category: '科幻末世',
    cover: 'https://readdy.ai/api/search-image?query=post-apocalyptic%20anime%20illustration%20of%20survivors%20with%20gear%20standing%20on%20a%20ruined%20city%20at%20sunset%2C%20muted%20orange%20and%20gray%20palette%2C%20survival%20manga%20cover%2C%20desolate%20atmosphere%2C%20high%20detail&width=480&height=640&seq=manga-mori-13&orientation=portrait',
    tags: ['科幻', '末世', '战斗'], status: 'finished', views: 1650000, rating: 9.0,
    authors: '灰烬', chapters: 260, update: '2026-07-05',
    intro: '末世降临，城市沦为废墟。一支幸存者小队在报点站的指引下艰难求生，在绝望中寻找人类重生的希望之光。',
  },
  {
    slug: 'yufeng-chuanshuo', title: '御风传说', category: '玄幻修仙',
    cover: 'https://readdy.ai/api/search-image?query=wind%20element%20fantasy%20anime%20illustration%20of%20a%20youth%20controlling%20a%20tornado%20of%20leaves%2C%20green%20and%20gold%20palette%2C%20xuanhuan%20cultivation%20manga%20cover%2C%20dynamic%20wind%20effects%2C%20mystical%20and%20detailed&width=480&height=640&seq=manga-yufeng-14&orientation=portrait',
    tags: ['玄幻', '修仙', '冒险'], status: 'serializing', views: 980000, rating: 8.9,
    authors: '驭风', chapters: 134, update: '2026-08-14',
    intro: '天生能御风而行的少年叶风，立志成为天下最强的风之修士。他在修仙路上御风千里，追寻传说中的风之真谛。',
  },
  {
    slug: 'tiancai-xiaojie', title: '天才小姐', category: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=smart%20and%20cute%20anime%20girl%20character%20with%20glasses%20and%20laptop%2C%20sweet%20romance%20manga%20cover%2C%20soft%20warm%20and%20pink%20tones%2C%20campus%20background%2C%20charming%20and%20detailed&width=480&height=640&seq=manga-tiancai-15&orientation=portrait',
    tags: ['恋爱', '校园', '甜宠'], status: 'finished', views: 880000, rating: 8.8,
    authors: '甜橘', chapters: 168, update: '2026-06-25',
    intro: '高冷的天才学霸小姐，其实是个一恋爱就冒粉红泡泡的可爱女孩。校园甜宠恋爱喜剧，又甜又好笑。',
  },
  {
    slug: 'mengzhong-zhidao', title: '梦中之岛', category: '悬疑推理',
    cover: 'https://readdy.ai/api/search-image?query=surreal%20mystery%20anime%20illustration%20of%20a%20floating%20island%20in%20a%20dreamlike%20sky%2C%20purple%20and%20teal%20dream%20palette%2C%20mind%20bending%20manga%20cover%2C%20mystical%20atmosphere%2C%20surreal%20and%20detailed&width=480&height=640&seq=manga-mengzhong-16&orientation=portrait',
    tags: ['悬疑', '推理', '反转'], status: 'serializing', views: 1040000, rating: 9.0,
    authors: '梦游者', chapters: 54, update: '2026-08-16',
    intro: '每次入睡，主角都会进入一座神秘之岛。岛上的每个谜题都与现实相连，当梦境与现实交错，真相逐渐浮现。',
  },
  {
    slug: 'huoyan-qingchun', title: '火焰青春', category: '热血冒险',
    cover: 'https://readdy.ai/api/search-image?query=youth%20sports%20anime%20illustration%20of%20a%20basketball%20player%20leaping%20for%20a%20slam%20dunk%20under%20bright%20lights%2C%20warm%20orange%20and%20red%20tones%2C%20energetic%20manga%20cover%2C%20dynamic%20action%2C%20detailed&width=480&height=640&seq=manga-huoyan-17&orientation=portrait',
    tags: ['热血', '友情', '校园'], status: 'finished', views: 1900000, rating: 9.3,
    authors: '传球手', chapters: 280, update: '2026-07-15',
    intro: '一支垫底篮球队，在少年们的汗水与热血中一步步逆袭。关于青春、友谊与梦想的燃情篮球物语。',
  },
  {
    slug: 'longcheng-kuangxiang', title: '龙城狂想', category: '玄幻修仙',
    cover: 'https://readdy.ai/api/search-image?query=majestic%20dragon%20fantasy%20anime%20illustration%20of%20a%20dragon%20soaring%20over%20an%20ancient%20walled%20city%2C%20gold%20and%20crimson%20palette%2C%20epic%20xuanhuan%20manga%20cover%2C%20mythical%20and%20detailed%20linework&width=480&height=640&seq=manga-longcheng-18&orientation=portrait',
    tags: ['玄幻', '战斗', '冒险'], status: 'serializing', views: 1230000, rating: 9.2,
    authors: '龙渊', chapters: 102, update: '2026-08-16',
    intro: '在龙族与人类共存的龙城大陆，少年龙裔觉醒上古血脉，于万族争锋的时代里崛起，书写属于自己的龙之狂想。',
  },
  {
    slug: 'zhandou-tongmeng', title: '战斗同盟', category: '科幻末世',
    cover: 'https://readdy.ai/api/search-image?query=hero%20team%20sci-fi%20anime%20illustration%20of%20a%20group%20of%20young%20heroes%20with%20power%20auras%20standing%20together%2C%20warm%20and%20cool%20contrast%2C%20alliance%20manga%20cover%2C%20epic%20team%20battle%2C%20detailed&width=480&height=640&seq=manga-zhandou-19&orientation=portrait',
    tags: ['科幻', '战斗', '友情'], status: 'finished', views: 1180000, rating: 8.9,
    authors: '纽带', chapters: 230, update: '2026-06-10',
    intro: '一群拥有各异能力的少年结成战斗同盟，共同对抗席卷世界的异常灾害。热血与羁绊并存的科幻战斗群像剧。',
  },
  {
    slug: 'tiankong-xiaoyuan', title: '天空校园', category: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=whimsical%20school%20anime%20illustration%20of%20a%20floating%20school%20building%20in%20the%20sky%20with%20students%2C%20bright%20cheerful%20colors%2C%20comedy%20manga%20cover%2C%20fun%20and%20playful%2C%20detailed%20and%20charming&width=480&height=640&seq=manga-tiankong-20&orientation=portrait',
    tags: ['搞笑', '校园', '日常'], status: 'serializing', views: 760000, rating: 8.6,
    authors: '气球', chapters: 92, update: '2026-08-11',
    intro: '一所漂浮在天空中的神奇学校，每天都在上演不可思议的爆笑日常。脑洞大开的校园喜剧。',
  },
  {
    slug: 'xiyuan-mima', title: '西园密码', category: '悬疑推理',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20garden%20mystery%20anime%20illustration%20of%20a%20gate%20and%20overgrown%20garden%20with%20hidden%20symbols%2C%20deep%20green%20and%20gold%20tones%2C%20detective%20manga%20cover%2C%20mysterious%20and%20intricate%2C%20detailed&width=480&height=640&seq=manga-xiyuan-21&orientation=portrait',
    tags: ['悬疑', '推理', '反转'], status: 'serializing', views: 920000, rating: 8.9,
    authors: '园丁', chapters: 66, update: '2026-08-12',
    intro: '一座荒废的西方园林里藏着破解家族秘密的密码。年轻侦探与园丁之女联手解谜，揭开尘封百年的真相。',
  },
  {
    slug: 'mofang-shaonv', title: '魔法少女祭', category: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=magical%20girl%20anime%20illustration%20of%20a%20sparkly%20girl%20with%20a%20magic%20wand%20and%20sparkles%2C%20soft%20pink%20and%20lavender%20with%20warm%20accents%2C%20sweet%20fantasy%20manga%20cover%2C%20magical%20and%20charming%2C%20detailed&width=480&height=640&seq=manga-mofang-22&orientation=portrait',
    tags: ['恋爱', '奇幻', '甜宠'], status: 'finished', views: 830000, rating: 8.7,
    authors: '星糖', chapters: 120, update: '2026-06-20',
    intro: '平凡少女意外成为魔法少女，却在战斗中遇见了命中注定的那个人。奇幻与恋爱交织的甜蜜物语。',
  },
  {
    slug: 'xiaoyao-jianke', title: '逍遥剑客', category: '热血冒险',
    cover: 'https://readdy.ai/api/search-image?query=carefree%20wandering%20swordsman%20anime%20illustration%20in%20a%20bamboo%20forest%2C%20green%20and%20gold%20palette%2C%20wuxia%20manga%20cover%2C%20graceful%20and%20heroic%2C%20misty%20atmosphere%2C%20detailed&width=480&height=640&seq=manga-xiaoyao-23&orientation=portrait',
    tags: ['热血', '冒险', '战斗'], status: 'finished', views: 1500000, rating: 9.0,
    authors: '醉剑', chapters: 300, update: '2026-07-10',
    intro: '一壶浊酒一柄剑，逍遥剑客行走江湖，快意恩仇。在刀光剑影之间，仗剑行侠的武侠传奇。',
  },
  {
    slug: 'chongqi-mingri', title: '重启明日', category: '科幻末世',
    cover: 'https://readdy.ai/api/search-image?query=time%20loop%20sci-fi%20anime%20illustration%20of%20a%20girl%20facing%20a%20glowing%20clock%20and%20futuristic%20city%2C%20teal%20and%20amber%20palette%2C%20reset%20the%20future%20manga%20cover%2C%20conceptual%20and%20detailed&width=480&height=640&seq=manga-chongqi-24&orientation=portrait',
    tags: ['科幻', '反转', '治愈'], status: 'serializing', views: 1120000, rating: 9.1,
    authors: '时针', chapters: 84, update: '2026-08-15',
    intro: '少女发现自己被困在时间的循环中，每一次重启都让她更接近真相。为了拯救世界与重要的人，她必须找到打破循环的钥匙。',
  },
];